export default __webpack_public_path__ + "static/media/Pointer.6a1fdd1e.png";